import { render, staticRenderFns } from "./ManageEducation.vue?vue&type=template&id=6f05d609&scoped=true"
import script from "./ManageEducation.vue?vue&type=script&lang=js"
export * from "./ManageEducation.vue?vue&type=script&lang=js"
import style0 from "./ManageEducation.vue?vue&type=style&index=0&id=6f05d609&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f05d609",
  null
  
)

export default component.exports